var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service.ts";
import { Prop, Emit, Watch } from "vue-property-decorator";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import FileUpload from '~/components/common/file-upload.vue';
import { FileUploadService } from "~/services/file-service/file-upload.service";
var CollectionExecutionModule = namespace("collection-execution");
var VisitActionArea = /** @class */ (function (_super) {
    __extends(VisitActionArea, _super);
    function VisitActionArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.personalInfo = {};
        _this.submitLoading = false;
        _this.signPaperType = [];
        _this.fileList = [];
        _this.rules = {
            custType: [{ required: true, message: '请选择催收对象' }],
            relationship: [{ required: true, message: '请选择关系' }],
            targetName: [{ required: true, message: '请输入姓名' }],
            addressType: [{ required: true, message: '请选择地址类型' }],
            addressDetail: [{ required: true, message: '请输入外访地址' }],
            addressStatus: [{ required: true, message: '请选择地址核实' }],
            debtorStatus: [{ required: true, message: '请选择债务人情况' }],
            carStatus: [{ required: true, message: '请选择车辆情况' }],
            repaymentStatus: [{ required: true, message: '请选择还款情况' }],
            riskAssessment: [{ required: true, message: '请选择风险评估' }],
            followTime: [{ required: true, message: '请选择跟进时间' }],
            propertyClues: [{ required: true, message: '请输入财产线索' }],
        };
        _this.applyModel = {
            custType: null,
            relationship: null,
            targetName: null,
            addressType: null,
            addressDetail: null,
            addressStatus: null,
            caseId: null,
            debtorStatus: null,
            carStatus: null,
            repaymentStatus: null,
            riskAssessment: null,
            followTime: null,
            propertyClues: null,
            followContent: null,
            personalOpinions: null,
            signPaperType: [],
            enclosureUrls: [],
            hasSync: undefined,
            archiveNo: undefined
        };
        return _this;
    }
    VisitActionArea.prototype.emitSuccess = function () {
        this.submitLoading = false;
        this.$message.success("操作成功");
        this.reset();
    };
    VisitActionArea.prototype.onCaseId = function () {
        var _this = this;
        if (this.caseId) {
            this.caseOperatorPageService.personalInfo(this.caseId).subscribe(function (data) {
                _this.personalInfo = data;
            });
        }
    };
    VisitActionArea.prototype.reset = function () {
        var form = this.$refs["form"];
        try {
            form.resetFields();
        }
        catch (error) {
            console.log('[visit-action-area:(227)]:: ', error);
        }
        this.fileList = [];
    };
    VisitActionArea.prototype.submit = function () {
        var _this = this;
        var form = this.$refs["form"];
        form.validate(function (result) {
            var _a;
            if (!result)
                return;
            if (_this.menuChannel === MENU_CHANNEL.Assist_visit) {
                _this.applyModel.assistId = _this.otherData.assistId;
            }
            _this.applyModel.caseId = _this.caseId;
            _this.submitLoading = true;
            var urls = [];
            _this.fileList.forEach(function (element) {
                if (element.response) {
                    urls.push(element.response.id);
                }
            });
            _this.applyModel.enclosureUrls = urls;
            //REPAIR [2026-03-24] 档案编号
            _this.applyModel.archiveNo = (_a = _this.topInfo) === null || _a === void 0 ? void 0 : _a.archiveNo;
            _this.caseOperatorPageService
                .addCaseFollowupRecord([CASE_CHANNEL.visit], _this.applyModel)
                .subscribe(function (data) {
                _this.emitSuccess();
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    VisitActionArea.prototype.onChange = function (val) {
        this.applyModel.targetName =
            val === "SELF" ? this.personalInfo.personalName : "";
    };
    VisitActionArea.prototype.showAddressDetail = function () {
        this.applyModel.custType = this.phoneData.custType;
        this.applyModel.relationship = this.phoneData.relation;
        this.applyModel.targetName = this.phoneData.contName;
        this.applyModel.addressType = 'HOUSE_ADDR';
        this.applyModel.addressDetail = this.phoneData.contAddress;
    };
    VisitActionArea.prototype.getAddressDetail = function () {
        var _this = this;
        this.applyModel.caseId = this.caseId;
        if (!this.phoneData) {
            this.caseOperatorPageService
                .getPersonalContactInfo(this.applyModel)
                .subscribe(function (data) {
                if (data.id) {
                    _this.applyModel.custType = data.custType;
                    _this.applyModel.relationship = data.relation;
                    _this.applyModel.targetName = data.contName;
                    switch (_this.applyModel.addressType) {
                        case 'HOUSE_ADDR':
                            _this.applyModel.addressDetail = data.contAddress;
                            break;
                        case 'IDCARD_ADDR':
                            _this.applyModel.addressDetail = data.idCardAddress;
                            break;
                        case 'COMPANY_ADDR':
                            _this.applyModel.addressDetail = data.companyAddress;
                            break;
                        default:
                            // this.applyModel.addressType = 'HOUSE_ADDR'
                            _this.applyModel.addressDetail = data.contAddress;
                            break;
                    }
                }
                else {
                    _this.applyModel.targetName = null;
                    _this.applyModel.addressDetail = null;
                }
            }, function (err) {
            });
        }
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], VisitActionArea.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], VisitActionArea.prototype, "FileUpload", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], VisitActionArea.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], VisitActionArea.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], VisitActionArea.prototype, "otherData", void 0);
    __decorate([
        Prop()
    ], VisitActionArea.prototype, "topInfo", void 0);
    __decorate([
        Prop({ required: false })
    ], VisitActionArea.prototype, "phoneData", void 0);
    __decorate([
        Emit("success")
    ], VisitActionArea.prototype, "emitSuccess", null);
    __decorate([
        Watch("caseId", { immediate: true })
    ], VisitActionArea.prototype, "onCaseId", null);
    __decorate([
        Emit('close')
    ], VisitActionArea.prototype, "reset", null);
    VisitActionArea = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], VisitActionArea);
    return VisitActionArea;
}(Vue));
export default VisitActionArea;
